module.exports = require('../_components/@alicd/next-search/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/search/index.js
// module id = 660
// module chunks = 0